import {checkPosition, initFullWideSwiper} from "../components/helpers";
import { Yashare } from "../components/yashare";
import lozad from "lozad";

export function initNewsPageLanding() {
    let fullWideSwiper;
    let isLoading = false;
    let shouldNotLoad = false;
    let ajaxData = {
        newsNumber: 1,
        newsTypeId: +new URL(window.location).searchParams.get('type'),
        loadedNewsId: []
    };
    let newsTypeUrl = '/ajax/getNews/';
    const observer = lozad();
    const newsHolder = $('#all_news_holder');
    const preloader = $('#news_page_preloader');
    const partners = $('.partners');
    const mockData = `
        <section class="section bg-color-gray no-padding">
            <div class="container news-container bg-color-white padding-top-x1">
                <div class="news-wrapper" data-news-id="44">
                    <h2 class="h1 title">Юрий Горшков: Мы заслуженно победили "Сочи"</h1>
                    <div class="any-image">
                        <img  class="img lozad" data-src="./img/news-page/news-draft.jpg" alt="Описание изображения">
                    </div>
                    <p class="caption">Защитник "Крыльев Советов" Юрий Горшков, забивший первый мяч в Премьер-лиге, поделился эмоциями от матча 22-го тура Тинькофф РПЛ против "Сочи" (3:2).</p>
                    <div class="question-answer">
                        <div class="question">Поздравляем с победой! Эмоции сумасшедшие. Что сейчас больше радует – победа или первый гол в Премьер-лиге?</div>
                        <div class="answer">Конечно, победа. Для нашей команды сейчас самое важное – это три очка. Обидно было бы, если бы мы вели 2:0, а потом упустили преимущество и не выиграли бы.</div>
                    </div>
                    <div class="question-answer quote">
                        <div class="answer">Нереальный матч получился. Вели 2:0, вроде бы все хорошо, но в этот момент какая-то успокоенность нас чуть не погубила в этом матче. Не знаю, как объяснить, что произошло. Вся команда встала, перестали двигаться, пропустили два. Чуть не поплатились за это. Хорошо, что повезло, и залетел такой удар. Не знаю даже, какая минута была.</div>
                    </div>
    
                    <p>
                        Сегодня свой 50-й День рождения отмечает старший тренер "Крыльев Советов" Сергей Булатов! В составе нашей команды Сергей Александрович выступал в 1997-1998 годах. За это время он провёл за "Крылья" 29 матчей и забил 10 голов.
                    </p>
                    <p>
                        От всей души поздравляем Сергея Александровича с юбилеем, желаем ему крепкого здоровья, счастья, успехов во всех начинаниях, исполнения всех заветных желаний!
                    </p>
                    <ul class="ul meduim-text">
                        <li>Маркированный список</li>
                        <li>Пункт 2</li>
                        <li>Пункт 3 От всей души поздравляем Сергея Александровича с юбилеем, желаем ему крепкого здоровья, счастья, успехов во всех начинаниях, исполнения всех заветных желаний!</li>
                    </ul>
                    
                    <div class="full-wide-slide-swiper swiper margin-bottom-x1">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide any-image">
                                <img  class="img" src="./img/news-page/news-draft-2.jpg" alt="Описание изображения">
                            </div>
                            <div class="swiper-slide any-image">
                                <img  class="img" src="./img/news-page/news-draft-2.jpg" alt="Описание изображения">
                            </div>
                            <div class="swiper-slide any-image">
                                <img  class="img" src="./img/news-page/news-draft-2.jpg" alt="Описание изображения">
                            </div>
                            <div class="swiper-slide any-image">
                                <img  class="img" src="./img/news-page/news-draft-2.jpg" alt="Описание изображения">
                            </div>
                        </div>
                        <div class="swiper-button-next full-wide-slide-next"></div>
                        <div class="swiper-button-prev full-wide-slide-prev"></div>
                        <div class="full-wide-pagination"></div>
                    </div>
                    
                    <div class="ya-share-block margin-bottom-x1">
                        <h5 class="margin-bottom-18">Поделиться:</h5>
                        <div class="ya-share ya-share2 ya-share2_inited"            
                             data-yashare-news
                             data-url="абсолютный урл до новости"
                             data-title="Заголовок этой конкретной новости"
                             data-description="Описание этой конкретной новости"
                             data-image="абсолютный урл до картинки"
                        >
                            <div
                                    class="ya-share2__container ya-share2__container_size_l ya-share2__container_color-scheme_normal ya-share2__container_shape_round">
                                <ul class="ya-share2__list ya-share2__list_direction_horizontal">
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                </div>
            </div>
        </section>
    `;

    if ($('#good_wings_news_page_landing').length) newsTypeUrl = '/ajax/getGoodWingsNews/';
    if ($('#wings_tv_video_page_landing').length) ajaxData.newsTypeId = 3;
    new Yashare($('[data-yashare-news]'));
    fullWideSwiper = $(initFullWideSwiper());
    partners.parents('.section').addClass('bg-color-gray no-padding');
    partners.parents('.container').addClass('news-container bg-color-white');


    $(window).scroll(function () {
        checkPosition(newsHolder, [getNews]);
    });

    function getLoadedNewsId() {
        const loadedNews = $('[data-news-id]');
        const parsedNewsId = [];

        $.each(loadedNews, function (index, value) {
            const id = $(value).attr('data-news-id');

            if (parsedNewsId.includes(id)) return;
            parsedNewsId.push(id);
        });

        ajaxData.loadedNewsId = parsedNewsId;
    }

    function getNews() {
        if (isLoading || shouldNotLoad) return;

        isLoading = true;
        getLoadedNewsId();
        preloader.removeClass('hide');

        $.ajax({
            url: newsTypeUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify(ajaxData),
            success: (res) => {
                if (!res && !res.length) {
                    shouldNotLoadFunc();
                } else {
                    addNews(res);
                    ajaxData.newsNumber++;
                }
            },
            error: () => {
                addNews(mockData);
                ajaxData.newsNumber++;
                // shouldNotLoadFunc();
            },
        });
    }

    function shouldNotLoadFunc() {
        shouldNotLoad = true;
        isLoading = false;
        preloader.addClass('hide');
    }

    function addNews(data) {
        newsHolder.append(data);
        refreshPlugins(data);

        isLoading = false;

        observer.observe();
        preloader.addClass('hide');
    }

    function refreshPlugins() {
        if (fullWideSwiper.length > 1) {
            $.each(fullWideSwiper, function (index, item) {
                item.destroy();
            });
        } else if (fullWideSwiper.length === 1) {
            fullWideSwiper[0].destroy();
        }

        new Yashare($('[data-yashare-news]'));
        fullWideSwiper = $(initFullWideSwiper());
    }

}

